export default {
    ETS_ARCHIVED: 'archived',
    ETS_ACTIVE: 'active',
    ETS_FUTURE: 'future',
}